<template>
  <div class="batch_container">
    <div>
      <a-checkbox :checked="isCheckAll"
                  @change="checkAll">全选</a-checkbox>
      <a-space class="ml24"
               :size="10">
        <slot></slot>
      </a-space>
    </div>
    <slot name="right"></slot>
  </div>
</template>

<script>
export default {
  name: 'BatchCheck',
  model: {
    prop: 'isCheckAll',
    event: 'checkAll'
  },
  props: {
    isCheckAll: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  methods: {
    checkAll (e) {
      this.$emit('checkAll', e.target.checked)
    },
  },
}
</script>

<style scoped>
.batch_container {
  min-height: 54px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: #ffffff;
  padding: 0 20px;
}

.batch_container ::v-deep .ant-btn {
  height: 26px;
  line-height: 26px;
}

.batch_container >>> .ant-select-selection--single {
  height: 26px;
}
.batch_container >>> .ant-select-selection__rendered {
  line-height: 24px;
}
.batch_container >>> .ant-select-arrow {
  right: 8px;
}
.ml24 {
  margin-left: 16px;
}
>>>.ant-checkbox-inner{
  width: 20px;
  height: 20px;
  border: 1px solid #979797;
}

>>> .ant-checkbox-wrapper{
  font-size: 12px;
}
</style>


// WEBPACK FOOTER //
// src/components/focus/components/BatchCheck.vue